import React from 'react'
import type { WidgetProps } from '@rjsf/utils'
import { isPlainObject } from '../mergePatch'
import { layerFromFormContext, setFieldUploadingFromFormContext } from '../formContextHelpers'
import { RawReferenceFallback } from './RawReferenceFallback'
import { referenceWidgetRegistry } from './registry'

const extractConfig = (annotation: Record<string, unknown>): Record<string, unknown> => {
  const config: Record<string, unknown> = {}
  for (const [key, entryValue] of Object.entries(annotation)) {
    if (key !== 'kind') {
      config[key] = entryValue
    }
  }
  return config
}

export const ZocksReferenceWidget: React.FC<WidgetProps> = (props) => {
  const schema: unknown = props.schema
  const annotation = isPlainObject(schema) ? schema.zocksReference : undefined
  const kind = isPlainObject(annotation) ? annotation.kind : undefined
  const KindWidget = typeof kind === 'string' && Object.hasOwn(referenceWidgetRegistry, kind) ? referenceWidgetRegistry[kind] : undefined
  const Widget = KindWidget ?? RawReferenceFallback
  const config = isPlainObject(annotation) ? extractConfig(annotation) : {}

  return (
    <Widget
      value={String(props.value ?? '')}
      onChange={(value) => props.onChange(value)}
      disabled={Boolean(props.disabled || props.readonly)}
      required={Boolean(props.required)}
      label={props.label}
      config={config}
      layer={layerFromFormContext(props.registry.formContext)}
      id={props.id}
      setFieldUploading={setFieldUploadingFromFormContext(props.registry.formContext)}
    />
  )
}
